import DropdownOption from 'components/common/select/DropdownOption';
import CustomText from 'components/common/text/CustomText';
import { checkError } from 'lib/clinic/library';
import { indicationOptionList } from 'lib/clinic/mapper';
import {
  ICreateOptionValue,
  IOptionInfo,
  IOptionInfoValue,
  IOptionUi,
} from 'lib/types/clinic/projectTypes';
import { TValue } from 'lib/types/common';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface ProjectOptionDropdownProps {
  type: 'default' | 'advanced';
  optionValues: ICreateOptionValue;
  optionInfoList: IOptionInfo | null;
  onOptionChange: (type: 'default' | 'advanced', optionKey: string, value: TValue) => void;
}

const ProjectOptionDropdown = ({
  type,
  optionValues,
  optionInfoList,
  onOptionChange,
}: ProjectOptionDropdownProps) => {
  // SECTION: declare hooks
  const { t } = useTranslation();

  return (
    <StyledProjectOptionDropdown>
      {useMemo(
        () =>
          !!indicationOptionList.dropdown &&
          indicationOptionList.dropdown.map((option: IOptionUi) => {
            if (!optionInfoList) return;

            const { key: optionKey, title: optionLabel } = option;
            const optionValue = optionValues[optionKey]?.value;
            const optionInfo = optionInfoList[optionKey]?.values.map((option: IOptionInfoValue) => {
              return {
                value: option.value,
                label: option.description,
              };
            });

            if (checkError(optionValue) || !optionInfo) return;

            return (
              <div className="projectOption__item_box" key={option.key}>
                <div className="projectOption__title">
                  <CustomText fontSize={20} fontWeight={600} fontColor="#222">
                    {t(optionLabel)}
                  </CustomText>
                </div>
                <div className="projectOption__content">
                  <DropdownOption
                    value={optionValue || ''}
                    options={optionInfo}
                    onChange={(value: TValue) => {
                      onOptionChange(type, optionKey, value);
                    }}
                  />
                </div>
              </div>
            );
          }),
        [optionValues, optionInfoList],
      )}
    </StyledProjectOptionDropdown>
  );
};

const StyledProjectOptionDropdown = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  .projectOption__item_box {
    display: flex;
    column-gap: 20px;
    .projectOption__title {
      width: 163px;
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
    .projectOption__content {
      width: 100%;
      display: flex;
    }
  }
`;

export default ProjectOptionDropdown;
